import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { getIssuePath } from '../../../model/post';
import { Section } from '../index';

const Special = ({
  issue,
  lazyLoad
}) => {
  const {
    name: issueName,
    slug: issueSlug,
    description: issueDesc,
    tghpwipIssuesTaxonomyFeaturedImage: issueImage,
    tghpwipIssuesTaxonomyFeaturedImageHomeOverride: issueImageHomeOverride,
    tghpwipIssuesTaxonomySpecialTabTitle: tabTitle,
    posts: { nodes: issuePosts },
  } = issue;

  const imageAlt = issueImage?.nodes[0]?.altText;
  const imageOverrideAlt = issueImageHomeOverride?.nodes[0]?.altText;

  const image = (
    <>
      {issueImageHomeOverride?.nodes.length > 0 && (
        <GatsbyImage
          image={issueImageHomeOverride?.nodes[0]?.gatsbyImage}
          sizes="90vw"
          alt={imageOverrideAlt ? imageOverrideAlt : ''}
          loading={lazyLoad ? 'lazy' : 'eager'}
        />
      )}
      {issueImageHomeOverride?.nodes.length === 0 && issueImage?.nodes.length > 0 && (
        <GatsbyImage
          image={issueImage?.nodes[0]?.gatsbyImage}
          sizes="90vw"
          alt={imageAlt ? imageAlt : ''}
          loading={lazyLoad ? 'lazy' : 'eager'}
        />
      )}
    </>
  );

  return (
    <Section type="special" restPosts={issuePosts} issue={issue} panel={true}>
      <Link
        position="beforeRestPosts"
        to={getIssuePath(issueSlug)}
        className="special-issue-grid__intro intro-titles"
      >
        <div className="intro-titles__label">{issueName}</div>
        {tabTitle && <div className="intro-titles__name">{tabTitle}</div>}
      </Link>
      <div position="beforeRestPosts" className="special-issue-grid__title">
        {issueDesc}
      </div>
      <div position="afterPanel" className="special-issue-grid__background">
        {image}
      </div>
    </Section>
  );
};

export default Special;
